import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface DelayAlert {
    id: string; // appointment_id
    carrier: string;
    minutesLate: number;
    severity: 'CRITICAL';
    receivedAt: number;
}

interface AlertState {
    activeAlerts: DelayAlert[];
    addAlert: (alert: DelayAlert) => void;
    removeAlert: (id: string) => void;
    clearAll: () => void;
}

export const useDelayAlertStore = create<AlertState>()(
    persist(
        (set) => ({
            activeAlerts: [],
            addAlert: (alert) => set((state) => {
                // Avoid duplicates
                if (state.activeAlerts.some(a => a.id === alert.id)) return state;
                return { activeAlerts: [...state.activeAlerts, alert] };
            }),
            removeAlert: (id) => set((state) => ({
                activeAlerts: state.activeAlerts.filter(a => a.id !== id)
            })),
            clearAll: () => set({ activeAlerts: [] })
        }),
        {
            name: 'baywhiz-alerts',
        }
    )
);
